import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

import { Heading } from '@/components/ui/heading';

/**
 * A page's level-one heading on web, for a page whose design draws no visible title.
 *
 * Route changes move focus to the page's `h1`, and a screen reader names the page by it, so a
 * page without one gets neither. Native names the screen in its bar, so this draws nothing there.
 * A page that already draws a visible title makes that the heading instead of adding this.
 */
export function WebPageHeading({ children }: { children: string }) {
  if (!isWeb) {
    return null;
  }

  return (
    <Heading size="h1-lg" className="sr-only">
      {children}
    </Heading>
  );
}
